import { render, staticRenderFns } from "./OpeningHoursCustomDayCard.vue?vue&type=template&id=7796e8de&scoped=true&"
import script from "./OpeningHoursCustomDayCard.vue?vue&type=script&lang=js&"
export * from "./OpeningHoursCustomDayCard.vue?vue&type=script&lang=js&"
import style0 from "./OpeningHoursCustomDayCard.vue?vue&type=style&index=0&id=7796e8de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7796e8de",
  null
  
)

export default component.exports